import React from 'react';
/* import { AppContainer,setConfig } from 'react-hot-loader';
import { render } from 'react-dom'; */
/* import configureStore, { history } from './store/configureStore'; */
import { store, history } from "./store/store";
import Root from './components/Root';
/* import ReactDOM from 'react-dom'; */
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import * as serviceWorker from './serviceWorker';
import { getAuthToken, setAuthToken } from './services/auth';
import Cookies from 'universal-cookie';

/* const qs = require('query-string'); */
/* const store = configureStore(); */
const query = new URLSearchParams(window.location.search);
const token = query.get('token')

let showContent = true;

if (token) {
  setAuthToken(token);
  const cookies = new Cookies();
  if (cookies.get('mySavedUrl')) {
    showContent = false;
    console.log("redirect to " + cookies.get('mySavedUrl'));
    window.location.href = cookies.get('mySavedUrl');
  }
}


if (showContent) {

  axios.defaults.headers.common['Authorization'] = 'Bearer ' + getAuthToken();

  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<Root store={store} history={history} />);
  if (module.hot) {
    module.hot.accept('./components/Root', () => {
      const NewRoot = require('./components/Root').default;
      root.render(<NewRoot store={store} history={history} />);
    });
  }
}

/* setConfig({
  showReactDomPatchNotification: false
}) */

/* ReactDOM.render(<Root store={store} history={history}/>, document.getElementById('root'));


if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    ReactDOM.render(<NewRoot store={store} history={history}/>, document.getElementById('root'));
  });
} */

/*
render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('root')
    );
  });
}

 */
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
